import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useRatingAgenciesSection from './useRatingAgenciesSection';

const RatingAgencies = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll, isAbsolute, onToggleAbsolute } = useRatingAgenciesSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.RatingAgencies }
      header={ (
        <FilterSectionHeader
          title="RATING AGENCIES"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="ratingAgenciesFiltersAllCheckbox"
            />
          ) }
          rightSlot={ (
            <Checkbox
              label="Absolute Filter"
              checked={ isAbsolute }
              onChange={ onToggleAbsolute }
              dataTest="ratingAgenciesAbsoluteFilterCheckbox"
            />
          ) }
        />
      ) }
    >
      { items.map((item) => (
        <FilterItem key={ item.value } isExpandable={ false }>
          <Checkbox
            label={ item.name }
            checked={ selectedValues.includes(item.value) }
            onChange={ () => toggle(item.value) }
            dataTest={ `checkbox-ratingAgency-${ item.value }` }
          />
        </FilterItem>
      )) }
    </FilterSection>
  );
};

export default RatingAgencies;
